// Modules
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import VelocityTransitionGroup from 'velocity-react/velocity-transition-group';
import _ from 'lodash';

// Components
import Alert from './alert';

// Utils
import { slideClosed, slideOpen } from 'utils/transition-groups';

// Component
function Alerts({ alerts }) {
  return (
    <VelocityTransitionGroup className="alerts-wrapper" component="div" leave={slideClosed} enter={slideOpen}>
      { _.map(alerts, (alert) =>
        <Alert key={alert.id} alert={alert} />
      ) }
    </VelocityTransitionGroup>
  );
}


Alerts.propTypes = {
  alerts: PropTypes.arrayOf(PropTypes.object)
};

function mapStateToProps(state) {
  return {
    alerts: state.alerts.alerts
  };
}

// Exports
export default connect(mapStateToProps)(Alerts);
